import React from 'react'

export default function Schema() {
    return (
        <div id="schema" className="my-5">
            <h4>{`{}`} <strong>Schema JSON Data</strong></h4>
            <p><strong>Note:</strong> <code>id</code> and <code>name</code> must be unique.</p>
            <h4>1. Heading (type: "heading")</h4>
            <pre>
                <code>{`
{
  "type": "heading",
  "label": "Footer bottom"
}
  `}</code>
            </pre>

            <h4>2. Select (type: "select")</h4>
            <pre>
                <code>{`
{
  "type": "select",
  "label": "Container size",
  "name": "container",     
  "value": "fixed",
  "items": [
    { "name": "Fixed", "value": "fixed" },
    { "name": "Full width", "value": "full" }
  ]
}
  `}</code>
            </pre>

            <h4>3. Checkbox (type: "checkbox")</h4>
            <pre>
                <code>{`
{
  "type": "checkbox",
  "id": "show_logo",        
  "name": "show_logo",      
  "label": "Show logo",
  "value": true
}
  `}</code>
            </pre>
            <h4>4. Radio Field (type: "radio")</h4>
            <p>Use this field type when you want the user to choose one option from a predefined list.</p>
            <pre>
                <code>{`
{
  "type": "radio",
  "id": "radio",
  "name": "radio",
  "label": "Radio Options",
  "value": "option1",
  "items": [
    { "name": "Option 1", "value": "option1" },
    { "name": "Option 2", "value": "option2" },
    { "name": "Option 3", "value": "option3" }
  ]
}
  `}</code>
            </pre>

            <h4>5. Image File (type: "image_file")</h4>
            <pre>
                <code>{`
{
  "type": "image_file",
  "id": "logo_image",       
  "name": "logo_image",     
  "label": "Logo image",
  "height": "70px",
  "width": "200px",
  "alt_name": "logo_alt",
  "alt": "Logo",
  "value": ""
}
  `}</code>
            </pre>

            <h4>6. Editor (type: "editor")</h4>
            <pre>
                <code>{`
{
  "type": "editor",
  "id": "footer_content",   
  "name": "footer_content", 
  "label": "Footer content",
  "value": "<p>Lorem ipsum dolor sit amet.</p>"
}
  `}</code>
            </pre>

            <h4>7. Color Picker (type: "color_picker")</h4>
            <pre>
                <code>{`
{
  "type": "color_picker",
  "id": "footer_color",     
  "name": "footer_color",   
  "label": "Background color",
  "value": "#fafafa"
}
  `}</code>
            </pre>

            <h4>8. Range (type: "range")</h4>
            <pre>
                <code>{`
{
  "type": "range",
  "id": "radius",           
  "name": "radius",         
  "label": "Image radius",
  "value": 0,
  "min": 0,
  "max": 50,
  "step": 1,
  "unit": "%"
}
  `}</code>
            </pre>
            <h4>9. Text (type: "text") </h4>
            <pre>
                <code>{`
{
  "type": "text",
  "id": "heading",
  "name": "heading",
  "label": "Heading",
  "value": "Featured product",
  "placeholder": ""
}
  `}</code>
            </pre>

            <h4>10. Number (type: "number") </h4>
            <pre>
                <code>{`
{
  "type": "number",
  "id": "show_products",
  "name": "show_products",
  "label": "Show products",
  "value": 4,
  "min": 1
}
  `}</code>
            </pre>

            <h4>11. Nav Menu (type: "nav_menu") </h4>
            <pre>
                <code>{`
{
  "type": "nav_menu",
  "label": "Navigation",
  "name": "header_nav",
  "value": "",
  "items": []
}
  `}</code>
            </pre>

            <h4>12. Textarea (type: "textarea") </h4>
            <pre>
                <code>{`
{
  "type": "textarea",
  "name": "announcement_text",
  "label": "Text",
  "value": "Lorem ipsum...",
  "placeholder": "Enter text"
}
  `}</code>
            </pre>

            <h4>13. Products Category (type: "products_category") </h4>
            <pre>
                <code>{`
{
  "type": "products_category",
  "label": "Choose category",
  "name": "products_category",
  "value": ""
}
  `}</code>
            </pre>

            <h4>14. Category (type: "category") </h4>
            <pre>
                <code>{`
{
  "type": "category",
  "label": "Choose category",
  "name": "category",
  "value": ""
}
  `}</code>
            </pre>

            <h4>15. Blog (type: "blog") </h4>
            <pre>
                <code>{`
{
  "type": "blog",
  "label": "Choose blog",
  "name": "blog",
  "value": ""
}
  `}</code>
            </pre>

            <h4>16. Typography (type: "typography") </h4>
            <p><strong>Note:</strong> This type contains nested settings. Each nested field must also have a unique <code>name</code> or <code>id</code>.</p>
            <pre>
                <code>{`
{
  "name": "Typography",
  "type": "typography",
  "settings": [
    {
      "type": "select",
      "name": "heading_font",
      "label": "Heading font",
      "value": "Roboto",
      "items": [...]
    }
  ]
}
  `}</code>
            </pre>

            <h4>17. Colors (type: "colors") </h4>
            <pre>
                <code>{`
{
  "name": "Colors",
  "type": "colors",
  "settings": [
    {
      "type": "color_picker",
      "id": "body_bg_color",
      "name": "body_bg_color",
      "value": "#ffffff"
    }
  ]
}
  `}</code>
            </pre>

            <h4>18. Favicon (type: "favicon") </h4>
            <pre>
                <code>{`
{
  "name": "Favicon",
  "type": "favicon",
  "settings": [
    {
      "type": "image_file",
      "id": "image_scr",
      "name": "image_scr",
      "label": "Favicon image",
      "value": ""
    }
  ]
}
  `}</code>
            </pre>

            <h4>19. Social Button (type: "social_button") </h4>
            <pre>
                <code>{`
{
  "name": "Social button",
  "type": "social_button",
  "settings": [
    {
      "type": "text",
      "id": "facebook_link",
      "name": "facebook_link",
      "label": "Facebook",
      "value": ""
    }
  ]
}
  `}</code>
            </pre>
            <h4>20. Product Selector (type: "product") </h4>
            <p>Use this field type when you want the user to select one product from your product list.
The output will store a single product ID (or handle) which you can access inside your section as <code>section.selected_product</code>.</p>
            <pre>
                <code>{`
{
  "settings": [
    {
      "type": "product",
      "id": "single_product",
      "name": "selected_product",
      "label": "Select Product",
      "value": ""
    }
  ]
}
  `}</code>
            </pre>
            <p>You can access this in your section using:</p>
            <pre>
                <code>{`
{{section.selected_product}}
  `}</code>
            </pre>
            <p>Inside Handlebars, you will receive the full product object (not just an ID).</p>
            <pre>
                <code>{`
{{#with section.selected_product}}
  <h2>{{title}}</h2>
  {{rawHTML body_html}}
{{/with}}
  `}</code>
            </pre>

        </div>
    )
}
